import { render, staticRenderFns } from "./EditStore.vue?vue&type=template&id=4b624899&scoped=true&"
import script from "./EditStore.vue?vue&type=script&lang=js&"
export * from "./EditStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b624899",
  null
  
)

export default component.exports